module.exports = "/build/web/images/corona.2890a64ac35b417cd94b9ce087a0a8fd.png";


//////////////////
// WEBPACK FOOTER
// ./images/corona.png
// module id = 119
// module chunks = 11